import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useRef } from "react";
import { openOtherUserPanel } from "../../../../../../../../User/OtherUserPanel/functions";
import { UserForRanking } from "../../../../../../../../User/types";
import { UserAvatar } from "../../../../../../../../User/UserAvatar/UserAvatar";
import { ChangeCommenterAvatarElement } from "../../../../../types";

export function CommentLeftAvatarArea({
    postedUser,
    changeCommenterAvatarElement,
    commentNo,
}: {
    postedUser?: UserForRanking;
    changeCommenterAvatarElement: ChangeCommenterAvatarElement;
    commentNo: number;
}) {
    const c = useStyles();
    const avatarRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const el = avatarRef.current;
        if (el) {
            changeCommenterAvatarElement("add", commentNo, el);
            return () => {
                changeCommenterAvatarElement("remove", commentNo);
            };
        }
    }, [commentNo]);
    return (
        <div className={c.container}>
            <UserAvatar
                user={postedUser}
                colorNumber={postedUser?.userId ?? "noColor"}
                size={40}
                onClick={ev => {
                    ev.stopPropagation();
                    if (!postedUser) {
                        return;
                    }
                    openOtherUserPanel(postedUser.userId);
                }}
                className={postedUser ? "pointer" : undefined}
                avatarRef={avatarRef}
            />
        </div>
    );
}
const useStyles = makeStyles({
    container: {
        width: 60,
        display: "flex",
        flexDirection: "column",
    },
});
